import React from 'react';
export function BonosSection() {
  const bonos = [{
    num: 1,
    icon: '🛒',
    title: 'Lista de Compras Inteligente',
    desc: 'Lista organizada por categorías con marcas argentinas. Versión económica y premium. Lista para llevar al súper cada semana.',
    value: '$8.999'
  }, {
    num: 2,
    icon: '🍽️',
    title: 'Recetario Express — 30 Recetas',
    desc: '10 desayunos, 10 almuerzos y 10 cenas metabólicas. Tiempo máximo 20 minutos. Ingredientes del almacén de la esquina.',
    value: '$7.999'
  }, {
    num: 3,
    icon: '✨',
    title: 'Guía Piel, Cabello y Uñas en la Menopausia',
    desc: 'Rutinas, activos con evidencia y suplementos con dosis exactas. Lo que realmente funciona después de los 40.',
    value: '$6.999'
  }, {
    num: 4,
    icon: '🩸',
    title: 'Guía de Análisis de Sangre en la Menopausia',
    desc: 'Qué pedirle a tu médico, cómo leer resultados y valores reales para mujeres +40. Andá al consultorio con argumentos.',
    value: '$4.999'
  }, {
    num: 5,
    icon: '📓',
    title: 'Diario de Seguimiento de 30 Días',
    desc: 'Planilla diaria de comidas, síntomas, energía y sueño. Control de medidas más allá de la balanza.',
    value: '$5.999'
  }, {
    num: 6,
    icon: '🌙',
    title: 'Guía Anti-Sofocos y Trastornos del Sueño',
    desc: 'Qué alimentos disparan los sofocos y el protocolo nocturno completo para recuperar el descanso sin medicación.',
    value: '$9.999'
  }];
  return <div className="bg-brand-ink py-16 px-6" data-id="element-38">
      <div className="max-w-[960px] mx-auto" data-id="element-39">
        <span className="block text-[11px] font-bold tracking-[3px] uppercase text-brand-green text-center mb-2.5" data-id="element-40">
          🎁 6 BONOS ESTRATÉGICOS
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-2 uppercase" data-id="element-41">
          ✦ Siempre incluidos — sin costo extra ✦
        </h2>
        <p className="text-center text-brand-muted text-[15px] mb-9" data-id="element-42">
          Cada bono agrega valor real a tu MegaPack. Hoy todos GRATIS.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3.5" data-id="element-43">
          {bonos.map(bono => <div key={bono.num} className="bg-white/5 border border-brand-border rounded-lg py-5.5 px-4.5" data-id="element-44">
              <span className="text-[24px] mb-2.5 block" data-id="element-45">{bono.icon}</span>
              <span className="text-[10px] font-bold tracking-[2px] uppercase text-brand-gold font-display mb-1.5 block" data-id="element-46">
                Bono 0{bono.num}
              </span>
              <h3 className="font-display text-base text-white mb-2 uppercase leading-tight" data-id="element-47">
                {bono.title}
              </h3>
              <p className="text-[13px] text-white/80 mb-3 leading-relaxed" data-id="element-48">
                {bono.desc}
              </p>
              <div className="flex items-center gap-2.5" data-id="element-49">
                <span className="text-[12px] text-brand-muted line-through" data-id="element-50">
                  {bono.value}
                </span>
                <span className="bg-brand-green text-white text-[11px] font-bold py-1 px-3 rounded font-display tracking-[1px] uppercase" data-id="element-51">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-gradient-to-br from-[#071a0d] to-[#0d1a0f] border border-brand-green/25 rounded-xl p-8 text-center mt-6" data-id="element-52">
          <p className="text-[13px] text-brand-muted mb-2" data-id="element-53">
            Valor total de los 6 bonos
          </p>
          <span className="font-display text-[48px] font-bold text-brand-red block mb-0.5 line-through opacity-70 leading-none" data-id="element-54">
            $53.000 ARS
          </span>
          <p className="text-[12px] text-brand-muted mb-3" data-id="element-55">
            Valor real de los bonos
          </p>
          <span className="font-display text-[32px] font-bold text-brand-green block tracking-[1px] uppercase leading-tight" data-id="element-56">
            ✦ COMPLETAMENTE GRATIS ✦
          </span>
          <p className="text-[14px] text-brand-green mt-1 font-semibold" data-id="element-57">
            Con tu MegaPack — sin costo extra
          </p>
        </div>
      </div>
    </div>;
}